import { handleActions } from 'redux-actions';

import { createStandardTableReducer } from 'utils';

import actionTypes from './actionTypes';
import { NAME } from './constants';

const { actions } = createStandardTableReducer(NAME, null);

const initialState = {
	type: null,
	data: [],
};

const tableReducer = {
	[actionTypes.SET_TABLE_DATA]: (state, action) => {
		return {
			...state,
			type: action.payload.type,
			data: [...action.payload.data],
		};
	},
	[actionTypes.APPEND_TABLE_DATA]: (state, action) => {
		return {
			...state,
			type: action.payload.type,
			data: state.data.concat(action.payload.data),
		};
	},
	[actionTypes.REMOVE_TABLE]: () => initialState,
};

export default handleActions(tableReducer, initialState);

export { actions };
